import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 2BC4A4B6-119B-4637-BF3D-1FB9394E1F38
 * name information
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/information.svg
 * tags
 * - Settings 
 */
export const InformationIcon = createSvgIcon(<><path d="M13,9H11V7H13M13,17H11V11H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" /></>, 'InformationIcon');
export default InformationIcon